import { Observable } from 'rxjs';

import { Organization } from 'organization/organization';

export abstract class OrganizationRepositoryPort {
	public abstract observeOrganizationById(id: string): Observable<Organization>;

	public abstract saveOrganizations(
		organizations: Organization[]
	): Promise<void>;

	public abstract observeOrganizationByIds(
		ids: string[]
	): Observable<Organization[]>;
}
